"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureSettingIds = void 0;
var FeatureSettingIds;
(function (FeatureSettingIds) {
    FeatureSettingIds["GLOBAL_SEARCH"] = "2";
    FeatureSettingIds["CONTENT_MANAGER"] = "1001";
    FeatureSettingIds["ADMIN_SETTINGS"] = "1002";
    FeatureSettingIds["OUTCOME_ANALYTICS"] = "1003";
    FeatureSettingIds["ENABLE_ARTICLE_UPGRADE"] = "1004";
    FeatureSettingIds["PROFILE_BUILDER"] = "3";
    FeatureSettingIds["USER_CENTRAL_LANDING"] = "2002";
    FeatureSettingIds["ENABLE_NEW_UI"] = "2003";
    FeatureSettingIds["LANGUAGE_SETTING"] = "2004";
})(FeatureSettingIds = exports.FeatureSettingIds || (exports.FeatureSettingIds = {}));
//# sourceMappingURL=FeatureSettingIds.js.map